module.exports = __webpack_public_path__ + "img/03tab-fish.7b74d752.png";